import { gsap } from "gsap";

// Career page animation
const animateImg = document.querySelectorAll(".grid-images");
if (animateImg.length) {
  gsap.defaults({ ease: "power1" }); // Use "power1" ease for smoother scaling
  gsap.set(".grid-images img", { y: 0, scale: 0.5 }); // Start from a smaller scale

  gsap.to(".grid-images img", {
    opacity: 1,
    scale: 1, // Scale up to 1 (original size)
    stagger: 0.15,
    duration: 1.5,
  });
}
